import { render } from "./new_Survey.vue?vue&type=template&id=f61d3c4e"
import script from "./new_Survey.vue?vue&type=script&lang=js"
export * from "./new_Survey.vue?vue&type=script&lang=js"

import "./new_Survey.vue?vue&type=style&index=0&id=f61d3c4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__